export default __webpack_public_path__ + "static/media/logo_campus_color.4e156ed3.svg";